import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getSeats, addSeat, updateSeat } from "../api/seatApi";
import { showError } from "../utils/alert";

const initialForm = {
  seat_name: "",
  hierarchy_level: "",
  description: "",
};

export default function SeatForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadSeat();
    }
  }, [id]);

  const loadSeat = async () => {
    try {
      const res = await getSeats({ page: 1, per_page: 1000 });
      const seat = res.data.items.find((s) => s.id === parseInt(id));
      if (seat) {
        setForm({
          seat_name: seat.seat_name || "",
          hierarchy_level:
            seat.hierarchy_level != null ? String(seat.hierarchy_level) : "",
          description: seat.description || "",
        });
      } else {
        showError("Seat not found");
        navigate("/seats");
      }
    } catch (err) {
      showError("Failed to load seat");
      navigate("/seats");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.seat_name.trim()) {
      return showError("Seat name is required");
    }

    setLoading(true);
    try {
      const payload = {
        ...form,
        hierarchy_level: form.hierarchy_level
          ? Number(form.hierarchy_level)
          : null,
      };
      if (isEdit) {
        await updateSeat(id, payload);
      } else {
        await addSeat(payload);
      }
      navigate("/seats");
    } catch (err) {
      showError(isEdit ? "Failed to update seat" : "Failed to add seat");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Seat" : "Add Seat"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Seat" : "Add New Seat"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Seat name *</label>
              <input
                name="seat_name"
                className="form-control"
                value={form.seat_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Hierarchy level</label>
              <input
                name="hierarchy_level"
                type="number"
                className="form-control"
                value={form.hierarchy_level}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                name="description"
                className="form-control"
                rows="3"
                value={form.description}
                onChange={handleChange}
              />
            </div>
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/seats")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
